import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { combineLatest, Observable } from 'rxjs';
import { GlassHouseCardData } from '../../../../../../../models/print-cards/glass-house/glass-house-card-data';
import { map } from 'rxjs/operators';
import { StrainType } from '../../../../../../../models/enum/dto/strain-classification.enum';

@Injectable()
export class GlassHouseBusinessCardStackContentViewModel extends PrintCardContentViewModel {
  public readonly cardData$: Observable<GlassHouseCardData>;

  public readonly sidebarSectionBackgroundColor$ = combineLatest([this.cardData$, this.cardAccentColor$]).pipe(
    map(([cardData, accentColor]) => {
      if (accentColor) return accentColor;
      const type = cardData?.getStrainType();
      switch (type) {
        case StrainType.Indica:
        case StrainType.IndicaDominant:
          return '#00AEEF';
        case StrainType.Sativa:
        case StrainType.SativaDominant:
          return '#F9ED32';
        case StrainType.Hybrid:
        case StrainType.Blend:
          return '#55C2B6';
        case StrainType.CBD:
          return '#38B34A';
        default:
          return null;
      }
    })
  );

  public readonly priceStreamOverride$ = this.cardData$.pipe(
    map(cardData => cardData?.getOverridePriceStreamForLabelComponent())
  );
}
